exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-bordered>tbody>tr>td {\r\n  vertical-align: middle;\r\n  color: black;\r\n}\r\n\r\n@media print {\r\n\r\n  input,\r\n  label,\r\n  .panel-title,\r\n  .panel,\r\n  .dataTables_length,\r\n  select {\r\n    display: none !important;\r\n  }\r\n\r\n  #print_info {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .form-inline .form-control {\r\n    width: 230px !important;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/listhotel/listhotel.component.css
// module id = ../../../../../src/app/listhotel/listhotel.component.css
// module chunks = main